import styled from 'styled-components'

export const FieldLabel = styled.label`
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  margin: 30px 0 10px;

  @media only screen and (min-width: ${props => props.theme.breakpoints.lg}px) {
    font-size: 18px;
  }
`
export const TextField = styled.input`
  border: none;
  border-bottom: 1px solid #b8b8b8;
  padding: 10px 0px;
  font-size: 14px;

  @media only screen and (min-width: ${props => props.theme.breakpoints.lg}px) {
    font-size: 16px;
  }

  &:hover,
  &:focus,
  &:active {
    outline: none;
    cursor: default;
  }
`

export const DropDownFilter = styled.div`
  min-width: 33%;
  padding: 10px 15px;
`
export const FilterContainer = styled.div`
  margin: 10px 40px 10px 40px;
  background: #ffffff;
  box-shadow: 0px 8px 24px rgba(0, 0, 0, 0.1);
  border-radius: 10px;
  display: flex;
  flex-direction: row;

  @media (max-width: ${props => props.theme.breakpoints.md}px) {
    box-shadow: 0px 8px 24px 0px #0000001a;
    flex-direction: column;
  }
  @media (max-width: ${props => props.theme.breakpoints.sm}px) {
    margin: 10px 15px 10px 15px;
  }
`
